import React from 'react'
import SimpleError404 from 'ui/modules/emptyState/error404'

const NotFound = () => {
  return <SimpleError404 />
}

export default NotFound
